export default __webpack_public_path__ + "static/media/new-user.c482b507.png";